export default function HeroSection() {
  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20abstract%20background%20with%20warm%20deep%20red%20and%20dark%20amber%20gradient%20tones%2C%20subtle%20film%20grain%20texture%2C%20soft%20dramatic%20lighting%20from%20upper%20right%2C%20dark%20theater-inspired%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20artistic%20abstract%20composition%20with%20smooth%20color%20transitions&width=1600&height=900&seq=hero-bg-video-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-5">
              <i className="ri-fire-line text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-xs font-medium text-accent-300 whitespace-nowrap">每日更新 · 海量国产影片</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-background-50 leading-tight">
              91免费视频网站
              <span className="block text-accent-400 mt-1">国产高清免费视频在线观看</span>
            </h1>

            <p className="mt-3 md:mt-4 text-sm md:text-base text-background-300/90 max-w-[560px] mx-auto lg:mx-0 leading-relaxed">
              汇聚全网91国产免费视频与91传媒视频在线资源，涵盖剧情、合集、精选等多种类型。每日更新海量国产影片，高清画质流畅播放不缓冲，为您打造一站式的国产免费视频网站观影体验。
            </p>

            <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-7">
              <div className="flex items-center gap-1.5">
                <span className="text-lg md:text-xl font-bold text-accent-400">5000+</span>
                <span className="text-xs text-background-400 whitespace-nowrap">国产影片资源</span>
              </div>
              <div className="w-px h-5 bg-background-400/30 hidden sm:block"></div>
              <div className="flex items-center gap-1.5">
                <span className="text-lg md:text-xl font-bold text-accent-400">每日更新</span>
                <span className="text-xs text-background-400 whitespace-nowrap">50+ 新片</span>
              </div>
              <div className="w-px h-5 bg-background-400/30 hidden sm:block"></div>
              <div className="flex items-center gap-1.5">
                <span className="text-lg md:text-xl font-bold text-accent-400">高清不缓冲</span>
                <span className="text-xs text-background-400 whitespace-nowrap">流畅观影</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg w-5 h-5 flex items-center justify-center"></i>
                开始观影
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-background-50/10 border border-background-50/20 text-background-100 text-sm font-medium hover:bg-background-50/15 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
                浏览专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] bg-background-950/50">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20film%20reel%20and%20play%20button%20abstract%20composition%2C%20warm%20red%20and%20gold%20accents%20on%20dark%20background%2C%20film%20strip%20elements%20floating%2C%20modern%20minimalist%20design%2C%20luxurious%20cinema%20vibe%2C%20dramatic%20lighting%2C%20movie%20themed%20abstract%20art%2C%20high%20contrast%2C%20sleek%20and%20polished%20look%20with%20glowing%20warm%20highlights&width=800&height=600&seq=hero-visual-2026&orientation=landscape"
                alt="91免费视频网站 - 国产高清免费视频在线观看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center cursor-pointer">
                  <i className="ri-play-fill text-background-50 text-xl w-5 h-5 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-xs text-background-200 font-medium">热门推荐</p>
                  <p className="text-sm text-background-50 font-semibold">今日精选国产高清合集</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}